import { useEffect } from 'react';
import type { Modify, Nullable } from 'corgi-types';
import { noop } from 'lodash-es';

import type { CreateScriptOptions } from '../utils/script';
import { createScript } from '../utils/script';

interface UseScriptOptions extends Modify<CreateScriptOptions, { url: Nullable<string> }> {
  onDestroy?: () => void;
}

export const useScript = ({ onDestroy = noop, ...options }: UseScriptOptions) => {
  useEffect(() => {
    if (!options.url) {
      return;
    }

    const script = createScript(options);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      onDestroy();
    };
  }, []);
};
